module.exports = __webpack_public_path__ + "static/media/react-dev.28a69699.svg";